import { render } from "./IndovinaCapitaleView.vue?vue&type=template&id=49124e9f&class=template"
import script from "./IndovinaCapitaleView.vue?vue&type=script&lang=js"
export * from "./IndovinaCapitaleView.vue?vue&type=script&lang=js"

import "./IndovinaCapitaleView.vue?vue&type=style&index=0&id=49124e9f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__